var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 4h6M6 5h6M4 6h2m6 0h4M4 7h2m6 0h4M4 8h2m10 0h2M4 9h2m10 0h2M4 10h2m10 0h2M4 11h2m10 0h2M6 12h2m10 0h2M6 13h2m10 0h2M4 14h2m12 0h2M4 15h2m12 0h2M2 16h2m6 0h2m6 0h2M2 17h2m6 0h2m6 0h2M2 18h2m4 0h2m2 0h6M2 19h2m4 0h2m2 0h6M2 20h6m-6 1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#e2e2e2",
    d: "M6 6h4M6 7h4M6 8h2M6 9h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#bcbcbc",
    d: "M10 6h2m-2 1h2M8 8h6M8 9h6m-8 1h6m-6 1h6m-4 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5b1b00",
    d: "M14 8h2m-2 1h2m-8 5h2m-2 1h2m-4 1h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8da0a0",
    d: "M12 10h4m-4 1h4m-6 1h8m-8 1h8m-8 1h6m-6 1h6m-4 1h2m-2 1h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9b5000",
    d: "M6 14h2m-2 1h2m-4 1h2m-2 1h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#567c7c",
    d: "M16 14h2m-2 1h2m-4 1h4m-4 1h4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2d0e0a",
    d: "M8 16h2m-2 1h2m-4 1h2m-2 1h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/repair.32f6a0ece5836d47dca7fb58c3cc29f1.svg";
export { ForwardRef as ReactComponent };